"use client";
import type { SerializedDateValue } from "@/utils/date";
import { createContext } from "react";
import type { SchoolProfilePayload } from "./include";

export type SchoolLayoutContext = {
  school: SerializedDateValue<SchoolProfilePayload>;
};

const LayoutContext = createContext<SchoolLayoutContext>(null!);

export default LayoutContext;
